import { render, staticRenderFns } from "./BottomNavPreview.vue?vue&type=template&id=31bfd8b0&scoped=true"
import script from "./BottomNavPreview.vue?vue&type=script&lang=js"
export * from "./BottomNavPreview.vue?vue&type=script&lang=js"
import style0 from "./BottomNavPreview.vue?vue&type=style&index=0&id=31bfd8b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bfd8b0",
  null
  
)

export default component.exports